<template lang="pug">
v-container(fluid)
    v-row.justify-center
        v-col.d-flex.justify-space-around(v-if="allowSave || this.reservationItem && this.reservationItem.status ==='delivered'" cols="12" sm="4")
            v-btn(
                color="primary" :disabled="isOfferEmpty || isSaveButtonDisabled || givingOutFoodInProgress || this.reservationItem && this.reservationItem.status === 'delivered' || isAccepted || isRejected" :loading="saveInProgress"
                :min-height="buttonsMinHeight" :min-width="buttonsMinWidth"
                @click="onSaveButtonClick"
            )
                v-icon.mr-1 {{ saveButtonIcon }}
                span {{ saveButtonLabel }}
        v-col.d-flex.justify-space-around(cols="12" sm="4")
            v-btn( v-if=" !isGiveOutFoodButtonHidden || this.reservationItem && this.reservationItem.status === 'delivered'"
              :disabled="isGiveOutFoodButtonDisabled || isAccepted || isRejected" :loading="givingOutFoodInProgress"
              :min-height="buttonsMinHeight" :min-width="buttonsMinWidth"
              @click="onGiveOutFoodButtonClick"
            )
              v-icon.mr-1 far fa-utensils
              span {{ $t('orderPage.giveOutFoodButtonLabel') }}
        v-col.d-flex.justify-space-around(v-if="allowCancellation" cols="12" sm="4")
            v-btn(
                color="warning" :disabled="isCancelButtonDisabled || isAccepted || isRejected" :loading="cancellationInProgress"
                :min-height="buttonsMinHeight" :min-width="buttonsMinWidth"
                @click="onCancelButtonClick"
            )
                v-icon.mr-1 fas fa-ban
                span {{ $t('orderPage.buttonCancel') }}
        v-row.ma-0(v-if="$vuetify.breakpoint.smAndDown && isAcceptanceProcess && reservationItem && reservationItem.acceptanceStatus && reservationItem.acceptanceStatus.name === 'waitlisted'")
            v-col.text-center(cols="12")
              v-btn( :min-height="buttonsMinHeight" :min-width="buttonsMinWidth" color="success" @click="acceptOrderClick" :disabled="saveInProgress || this.reservationItem && this.reservationItem.status === 'canceled'" :loading="saveInProgress") {{ $t('orderPage.acceptOrder') }}
            v-col.text-center(cols="12")
              v-btn( :min-height="buttonsMinHeight" :min-width="buttonsMinWidth" color="error" @click="rejectOrderClick" :disabled="saveInProgress || this.reservationItem && this.reservationItem.status === 'canceled'" :loading="saveInProgress") {{ $t('orderPage.rejectOrder') }}
        v-toolbar.elevation-0(v-if="$vuetify.breakpoint.mdAndUp && isAcceptanceProcess && reservationItem && reservationItem.acceptanceStatus && reservationItem.acceptanceStatus.name === 'waitlisted'")
          v-row.ma-0
            v-col.text-start.pl-3(cols="6")
              v-btn(color="success" @click="acceptOrderClick" :disabled="saveInProgress" :loading="isAccepted") {{ $t('orderPage.acceptOrder') }}
            v-col.pr-5.text-end(cols="6")
              v-btn(color="error" @click="rejectOrderClick" :disabled="saveInProgress" :loading="isRejected") {{ $t('orderPage.rejectOrder') }}
</template>

<script lang="ts">
import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import moment from 'moment'
import { getLocale } from '@/services/system'
import { ReservationStatus } from '@/types/enums'
import MenuReservationItem from "@/model/dailymenu/MenuReservationItem";
import {Component, Prop, Watch} from "vue-property-decorator";
import MenuGroupItemOrder from "@/model/dailymenu/MenuGroupItemOrder";
import DailyMenuOptionOrder from "@/model/dailymenu/DailyMenuOptionOrder";
import i18n from "@/plugins/i18n";

@Component({
})

export default class GroupControlButtons extends Vue{

    @Prop({ type: Date, required: true }) date!: Date
    @Prop({ type: Object as () => MenuReservationItem | undefined }) reservationItem: MenuReservationItem | undefined
    @Prop({ type: Boolean, default: false }) saveInProgress!: boolean
    @Prop({ type: Boolean, default: false }) cancellationInProgress!: Boolean
    @Prop({ type: Boolean, default: false }) isSelectionChanged!: Boolean
    @Prop({type: Boolean, default: false}) givingOutFoodInProgress!: boolean
    @Prop({type: Boolean, default: false}) isOfferEmpty!: boolean
    @Prop({type: Boolean}) isAcceptanceProcess!: boolean
    @Prop({type: Boolean}) isRejected!: boolean
    @Prop({type: Boolean}) isAccepted!: boolean
    @Prop({ type: Boolean, default: false }) isAmountChanged!: Boolean

  private amount: number = 1

  @Watch('amount')
  watchAmount(newVal: number) {
    if(newVal) {
      this.amount = newVal
    }
  }

  get isNewAmount () {
    let foundItem: any | null = null
    this.reservationItem!.reservedOffers.forEach((item: any) => {
      foundItem = item.amount
    })
    if(foundItem === this.amount) {
      return true
    } else {
      return false
    }
  }

  get dateLabel (): string {
      return moment(this.date)
        .locale(i18n.locale)
        .format('dddd D.M YYYY').toLocaleLowerCase()
    }

     get saveButtonIcon (): string {
      if (this.reservationItem && this.reservationItem.status === 'canceled') {
        return 'fas fa-undo'
      }

      return 'fas fa-save'
    }

     get saveButtonLabel (): TranslateResult | undefined {
      if (!this.reservationItem) {
        return this.$t('orderPage.placeNewReservationButtonLabel')
      } else if (this.reservationItem && this.reservationItem.status === ReservationStatus.active) {
        return this.$t('orderPage.changeReservationButtonLabel')
      } else if (this.reservationItem && this.reservationItem.status === ReservationStatus.canceled) {
        return this.$t('orderPage.restoreReservationButtonLabel')
      } else if (this.reservationItem && this.reservationItem.status === ReservationStatus.delivered) {
        return this.$t('orderPage.changeReservationButtonLabel')
      }
      return undefined
    }

    get buttonsMinHeight (): number | undefined {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 80
      }

      return undefined
    }

    get buttonsMinWidth (): string | undefined {
      if (this.$vuetify.breakpoint.xsOnly) {
        return '100%'
      }

      return undefined
    }

    get isButtonDisabled (): boolean {
      if(this.reservationItem) {
        if(this.reservationItem.status === ReservationStatus.delivered ) {

        }
        return true
      } else {
        return false
      }
    }

    get isSaveButtonDisabled (): boolean {
      if (this.cancellationInProgress) {
        return true
      }

      if (this.reservationItem && this.reservationItem.status === ReservationStatus.active) {
        return !(this.isSelectionChanged || this.isAmountChanged)
      }

      return false
    }

    get isCancelButtonDisabled (): boolean {
      return this.saveInProgress
    }

    get isGiveOutFoodButtonDisabled(): boolean {
      if (this.cancellationInProgress || this.saveInProgress) {
        return true
      }

      return !(this.reservationItem?.status === ReservationStatus.active);

    }

    get isGiveOutFoodButtonHidden(): boolean {
      if (this.reservationItem) {
        if (this.reservationItem.status === ReservationStatus.delivered) {
          return true
        }
      }
      return false
    }

    get allowSave (): boolean {
      if (this.reservationItem && (['active', 'canceled'].includes(this.reservationItem.status))) {
        return true
      } else if (!this.reservationItem) {
        return true
      }

      return false
    }

    get allowCancellation (): boolean {
      if(this.reservationItem && this.reservationItem.status === ReservationStatus.active || this.reservationItem && this.reservationItem.status === ReservationStatus.delivered) {
        return true
      } else {
        return false
      }
    }


    // <editor-fold desc="Event handlers">
    onSaveButtonClick (): void {
      if (this.reservationItem && this.reservationItem.status === 'active') {
        this.$emit('changeReservationClick')
      } else if (this.reservationItem && this.reservationItem.status === 'canceled') {
        this.$emit('restoreReservationClick')
      } else {
        this.$emit('placeNewReservationClick')
      }
    }

  acceptOrderClick () {
    this.$emit('accepted')

  }

  rejectOrderClick () {
    this.$emit('rejected')
  }

    onCancelButtonClick (): void {
      this.$emit('cancelReservationClick')
    }

    onGiveOutFoodButtonClick(): void {
      if (this.reservationItem && this.reservationItem.status === 'active') {
        this.$emit('giveOutFoodClick')
      }
    }

    mounted () {
    }
    // </editor-fold>
}
</script>

<style lang="stylus" scoped>
</style>
